<template>
  <div>
    <RecognitionDialog
      v-if="type == ENTITY_TYPE.RECOGNITION"
      :show="type == ENTITY_TYPE.RECOGNITION"
      @saved="$emit('created')"
      @close="$emit('cancel')"
    />
    <ChallengeModal
      v-else-if="type == ENTITY_TYPE.CHALLENGE"
      :show="type == ENTITY_TYPE.CHALLENGE"
      @close="$emit('cancel')"
      @created="$emit('created')"
    />

    <CreateRevWrapper
      v-else
      :challengeId="challengeId"
      :type="type"
      :replicateRevData="replicateRevData"
      @created="$emit('created')"
      @error="$emit('error')"
      @loading="$emit('loading')"
      @visitSuggestion="$emit('visitSuggestion')"
    >
      <template slot-scope="{ create, cancel, isLoading, isValid }">
        <Button
          plain
          color="grey"
          :disabled="isLoading"
          :text="backButtonText"
          @click="cancel(), $emit('cancel')"
          data-testid="revs_modal_create_cancel"
          data-tourid="crevs_modal_create_cancel"
        />
        <Button
          color="primary"
          data-testid="create_rev_button"
          data-tourid="create_rev_button"
          :disabled="isValid"
          :loading="isLoading"
          :text="buttonText"
          @click="create"
        />
      </template>
    </CreateRevWrapper>
  </div>
</template>

<script>
import CreateRevWrapper from '@/components/CreateRevWrapper/CreateRevWrapper.vue'
import Button from '@/components/UI/Button.vue'
import ChallengeModal from '@/components/ChallengeModal/ChallengeModal.vue'
import RecognitionDialog from '@/components/RecognitionDialog.vue'

const ENTITY_TYPE = {
  QUICK_ACTION: 'quickAction',
  IMPROVEMENT_IDEA: 'improvementIdea',
  PROBLEM_SOLVING: 'problemSolving',
  CHALLENGE: 'challenge',
  RECOGNITION: 'recognition',
}

export default {
  name: 'FormStep',

  props: {
    type: {
      type: String,
      required: true,
    },

    challengeId: {
      type: String,
      required: false,
    },

    replicateRevData: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
  },

  data() {
    return {
      ENTITY_TYPE,
    }
  },

  computed: {
    buttonText() {
      if (this.replicateRevData) {
        return this.$t('common.button.replicate')
      }
      return this.$t('common.button.create')
    },

    backButtonText() {
      if (this.replicateRevData) {
        return this.$t('common.button.close')
      }

      return this.$t('common.button.back')
    },
  },

  components: {
    Button,
    CreateRevWrapper,
    ChallengeModal,
    RecognitionDialog,
  },
}
</script>
